import * as z from 'zod';

export const AudienceSchema = z.enum(['OPEN', 'MEMBERS_ONLY'])

export type Audience = z.infer<typeof AudienceSchema>;